import { render } from "./DeployButton.vue?vue&type=template&id=4f7da044&scoped=true&ts=true"
import script from "./DeployButton.vue?vue&type=script&lang=ts"
export * from "./DeployButton.vue?vue&type=script&lang=ts"

import "./DeployButton.vue?vue&type=style&index=0&id=4f7da044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7da044"]])

export default __exports__